// client/components/evaluate/ResolvedFromScopeBadge.tsx
// Task 4.6 — Badge showing which scope a human decision was inherited from
import React from 'react';
import type { EvidencePayload } from '../../hooks/useEvaluateData';

interface ResolvedFromScopeBadgeProps {
  decision: NonNullable<EvidencePayload['human_decision']>;
}

export function ResolvedFromScopeBadge({ decision }: ResolvedFromScopeBadgeProps) {
  const decidedAt = new Date(decision.decided_at).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
  });
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 10px',
        borderRadius: 9999,
        background: 'var(--tri-neutral-bg)',
        color: 'var(--tri-neutral)',
        fontSize: '0.72rem',
        fontFamily: 'JetBrains Mono, Consolas, monospace',
        border: '1px solid var(--tri-neutral)',
      }}
      title={decision.rationale ?? ''}
    >
      <span>&#8593; {decision.scope.display_name}</span>
      <span style={{ color: 'var(--tri-slate)' }}>· {decision.action} · {decision.decided_by.display_name} · {decidedAt}</span>
    </div>
  );
}
